
class heroVideo {

    constructor() {

        this.body = document.querySelector('body')
        this.section = document.querySelector('[data-hero-video]')
        this.siteHeader = document.querySelector('.site-header')
        this.overlay = document.querySelector('[data-hero-video-overlay]')
        this.playerContainer = this.section.querySelector('[data-hero-video-player-container]')
        this.player = this.section.querySelector('[data-hero-video-player]')
        this.playerBg = this.section.querySelector('[data-hero-video-bg]')
        this.trigger = this.section.querySelector('[data-hero-video-trigger]')
        this.closeBtn = this.section.querySelector('[data-hero-video-close]')

        if (this.section) {
            this.bindEvents();
        }

    }


    bindEvents() {

        this.trigger.addEventListener('click', () => {
            this.open();
        })

        this.overlay.addEventListener('click', () => {
            this.close();
        })

        this.closeBtn.addEventListener('click', () => {
            this.close();
        })

        document.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
                this.close(e);
            }
        });

    }

    open() {

        this.section.scrollIntoView({behavior: 'smooth'});
        this.playerContainer.classList.add('active');
        this.overlay.classList.add('active');
        this.siteHeader.style.pointerEvents = 'none';
        this.body.style.overflow = 'hidden';
        this.player.play();
        this.playerBg.pause();
    }

    close() {
        this.playerContainer.classList.remove('active');
        this.overlay.classList.remove('active');
        this.siteHeader.style.pointerEvents = 'auto';
        this.body.style.overflow = 'unset';
        this.player.pause();
        this.playerBg.play();
    }

}

new heroVideo();